// extracted by mini-css-extract-plugin
export default {"icons":"RolesAndPermission_icons__OyohZ","selected-icons":"RolesAndPermission_selected-icons__99z2h"};